'use client';
import React from 'react';
import { useLocale } from 'next-intl';
import { DirectionProvider } from '@/components/ui/direction';
import { QueryProvider } from '@/lib/query/client/query-provider';
import { AuthProvider } from '@/contexts/auth-context';
import { localeDirection, type Locale } from '@/i18n/config';
import { ActiveThemeProvider } from '../themes/active-theme';
import { FontProvider } from '../themes/font-context';
import { ApiLocaleSync } from './api-locale-sync';

export default function Providers({
  activeThemeValue,
  activeFontValue,
  activeFontArabicValue,
  children
}: {
  activeThemeValue: string;
  activeFontValue?: string;
  activeFontArabicValue?: string;
  children: React.ReactNode;
}) {
  const locale = useLocale();
  const dir = localeDirection[locale as Locale] ?? 'ltr';

  return (
    <DirectionProvider dir={dir}>
      <QueryProvider>
        <ApiLocaleSync />
        <AuthProvider>
          <ActiveThemeProvider initialTheme={activeThemeValue}>
            <FontProvider
              initialFont={activeFontValue}
              initialFontArabic={activeFontArabicValue}
            >
              {children}
            </FontProvider>
          </ActiveThemeProvider>
        </AuthProvider>
      </QueryProvider>
    </DirectionProvider>
  );
}
